import type { TableHeadParams } from '@hapvida/hapvida-core-components/src/components/BaseTable/types';

enum BillsListSortNameEnum {
  DUE_DATE = 'DueDate',
  AMOUNT = 'Amount',
  STATUS = 'Status',
  NUMBER = 'Number',
  PERIOD = 'Period',
  BILL_TYPE = 'BillType',
}

const BillsListColumns: TableHeadParams[] = [
  /* TO-DO: funcionalidade ocultada a pedido da área de negócios
  {
    id: 1,
    label: '',
    name: '',
    cellWidth: 10,
  }, */
  {
    id: 1,
    label: 'Nº documento',
    name: BillsListSortNameEnum.NUMBER,
  },
  {
    id: 2,
    label: 'Vencimento',
    name: BillsListSortNameEnum.DUE_DATE,
  },
  // TO-DO: Funcionalidade ocultada a pedido da área de negócios, comentada por enquanto
  // {
  //   id: 3,
  //   label: 'Emissão',
  //   name: BillsListSortNameEnum.PERIOD,
  // },
  {
    id: 4,
    label: 'Valor',
    name: BillsListSortNameEnum.AMOUNT,
  },
  {
    id: 5,
    label: 'Status',
    name: BillsListSortNameEnum.STATUS,
  },
  {
    id: 6,
    label: 'Tipo fatura',
    name: BillsListSortNameEnum.BILL_TYPE,
    sortable: false,
  },
  {
    id: 7,
    label: '',
    name: '',
    cellWidth: 80,
  },
];

const BillsSummaryColumns = [
  {
    id: 1,
    label: 'Beneficiário',
    name: 'beneficiary',
  },
  {
    id: 2,
    label: 'Tipo',
    name: 'beneficiaryType',
  },
  {
    id: 3,
    label: 'Paciente',
    name: 'patient',
  },
  {
    id: 4,
    label: 'Descrição/Despesa',
    name: 'descriptionExpenses',
  },
  {
    id: 5,
    label: 'Valor fator',
    name: 'factorValue',
  },
];

export { BillsSummaryColumns, BillsListColumns, BillsListSortNameEnum };
